import { ServicesHero } from '../components/sections/ServicesHero';
import { ServicesDetail } from '../components/sections/ServicesDetail';
import { ServicesLoanTypes } from '../components/sections/ServicesLoanTypes';
import { ServicesProcess } from '../components/sections/ServicesProcess';
import { ServicesCTA } from '../components/sections/ServicesCTA';

const Services = () => (
  <div>
    <ServicesHero />
    <ServicesDetail />
    <ServicesLoanTypes />
    <ServicesProcess />
    <ServicesCTA />
  </div>
);

export default Services;
